export const platformName = (platform) => platform === "tiktok" ? "TikTok" : "Meta";
export const pixelKey = (pixel) => `${pixel.platform}:${pixel.id}`;
export const pixelName = (pixel) => pixel?.name || (pixel ? `${platformName(pixel.platform)} · ${String(pixel.pixel_id).slice(-4)}` : "Unavailable pixel");

export function normalizeProductId(value) {
  const match = String(value || "").trim().match(/^(?:gid:\/\/shopify\/Product\/)?(\d{1,32})$/);
  return match ? match[1].replace(/^0+/, "") : "";
}

export function pixelResponse(response) {
  if (Number(response?.status) !== 200 || !response?.data) {
    const error = new Error(response?.msg || "The request could not be completed. Please try again.");
    error.response = { data: response };
    throw error;
  }
  return response.data;
}

export function pixelError(error) {
  const body = error?.response?.data;
  const fields = body?.data?.errors || body?.errors || {};
  return Object.values(fields).flat()[0] || body?.msg || body?.message || error?.message || "The request could not be completed. Please try again.";
}

export function upsertById(items, item) {
  return items.some((entry) => String(entry.id) === String(item.id))
    ? items.map((entry) => String(entry.id) === String(item.id) ? item : entry)
    : [...items, item];
}
